import { WithGrow } from "@common/components/WithGrow";
import { EditRounded } from "@mui/icons-material";
import { Divider, styled, Paper, Checkbox, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { PropsWithChildren } from "react";

export const Card = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(0.5),
  marginLeft: 0,
  boxShadow: "none",
  backgroundImage: "none",
}));

export interface CardHeaderProps {
  onEdit?: () => void;
  onSelect?: () => void;
  disabled?: boolean;
  deleteDisabled?: boolean;
  editDisabled?: boolean;
}
const WithCheckBox = ({
  onSelect,
  disabled,
  children,
}: PropsWithChildren<Pick<CardHeaderProps, "onSelect" | "disabled">>) =>
  onSelect ? (
    <WithGrow
      height="fit-content"
      direction="row"
      fixedSx={{ alignItems: "center" }}
      fixed={<Checkbox onChange={onSelect} disabled={disabled} data-testid="card-checkbox" />}
    >
      {children}
    </WithGrow>
  ) : (
    <>{children}</>
  );

const WithEditButton = ({
  onEdit,
  disabled,
  children,
}: PropsWithChildren<Pick<CardHeaderProps, "onEdit" | "disabled">>) =>
  onEdit ? (
    <WithGrow
      height="fit-content"
      direction="row-reverse"
      fixedSx={{ alignItems: "center" }}
      fixed={
        <IconButton color="primary" onClick={onEdit} disabled={disabled} data-testid="card-edit-button">
          <EditRounded />
        </IconButton>
      }
    >
      {children}
    </WithGrow>
  ) : (
    <>{children}</>
  );
export const CardHeader = (props: PropsWithChildren<CardHeaderProps>) => {
  const {
    children,
    onEdit,
    onSelect,
    disabled = false,
    deleteDisabled = false,
    editDisabled = false,
  } = props;
  return (
    <>
      <WithCheckBox onSelect={onSelect} disabled={disabled || deleteDisabled}>
        <WithEditButton onEdit={onEdit} disabled={disabled || editDisabled}>
          <Grid
            container
            direction="row"
            wrap="nowrap"
            sx={{ width: '100%', overflow: "hidden" }}
          >
            {children}
          </Grid>
        </WithEditButton>
      </WithCheckBox>
      <Divider sx={{ marginTop: 0.5 }} />
    </>
  );
};

export default Card;
